

export type AuthState = {
  token: string | null
  setToken: (token: string | null) => void
  isLoggedIn: () => boolean
}

export const authStore: AuthState = {
  token: localStorage.getItem("token"),

  setToken(token) {
    if (token) {
      localStorage.setItem("token", token)
    } else {
      localStorage.removeItem("token")
    }
    this.token = token
  },

  isLoggedIn() {
    return !!this.token
  }
}
